jQuery(document).ready(function ($) {
  // Loop through every search wrapper on the page
  $(".lableb-search-wrapper").each(function () {
    const wrapper = $(this);
    const searchInput = wrapper.find(".lableb-search-bar");
    const suggestionsBox = wrapper.find(".lableb-suggestions");
    let debounceTimeout = null;

    // Input listener
    searchInput.on("input", function () {
      const query = $(this).val().trim();

      if (debounceTimeout) clearTimeout(debounceTimeout);

      if (!query) {
        suggestionsBox.hide().empty();
        return;
      }

      debounceTimeout = setTimeout(() => {
        $.ajax({
          url: lablebSearchBarAjax.ajaxUrl,
          type: "POST",
          data: {
            action: "get_search_recommendation",
            nonce: lablebSearchBarAjax.nonce,
            search_query: query,
          },
          success: function (response) {
            if (
              !response.success ||
              !response.data ||
              response.data.html === ""
            ) {
              suggestionsBox.hide().empty();
              return;
            }

            suggestionsBox.html(response.data.html).show();
          },
          error: function (xhr, status, error) {
            console.error("AJAX Error:", error);
            suggestionsBox.hide().empty();
          },
        });
      }, 500);
    });

    // Clicking a suggestion
    wrapper.on("click", ".lableb-suggestion-item", function () {
      const postID = $(this).data("lableb-id");
      const query = searchInput.val().trim();
      $.ajax({
        url: lablebSearchBarAjax.ajaxUrl,
        type: "POST",
        data: {
          action: "send_search_feedback",
          nonce: lablebSearchBarAjax.feedback_nonce,
          search_query: query,
          post_id: postID,
          type: "autocomplete",
        },
        success: function (response) {
          // Feedback sent successfully
        },
      });
      setTimeout(() => {
        const url = $(this).data("url");
        if (url) window.location.href = url;
      }, 100);
    });

    // Hide suggestions when clicking outside this component
    $(document).on("click", function (e) {
      if (!$(e.target).closest(wrapper).length) {
        suggestionsBox.hide();
      }
    });
  });
});
